import React, { useEffect, useState } from "react";
import * as jnb from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import axios from "axios";
import { Container, Table, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import {  useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { config } from "../../../CommonUtils/CommonUrl/CommonUrls";
import CommonPost from "../../../CommonUtils/CommonAxios/CommonPost";
import { failureAlert } from "../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts";
import Header from "../../../Header/Header";
import { CommonAxiosGet, CommonAxiosPost, CommonAxiosPut } from "../../../CommonUtils/CommonAxios/CommonAxios";

export default function MandalsMapped() {

let navigate = useNavigate();
  const lgdDisttcode = localStorage.getItem("lgd_dist_code");
  const [MappedMandals, setMappedMandals] = useState([]);
 
  function MandalsMappedData() {
    // http://172.17.205.80:8889/labor/districtwisedashboard/mandalcompleted/519
    const URLL = config.url.BOC_URL + "districtwisedashboard/mandalcompleted/" + lgdDisttcode;
    console.log("MANDALS COMPLETED URL>", URLL);
    CommonAxiosGet(URLL).then((res) => {
      if (res.data.scode === "01") {
        setMappedMandals(res.data.DATA);
        console.log("madals",MappedMandals)
       // setOrgDataByMappedMandals(res.data.DATA)
      //  console.log("COMPLETED MANDALS DATA", res.data.DATA);
        for (let i = 0; i < res.data?.DATA?.length; i++) {
        formIk.setFieldValue(
          `alos[${i}].org_id`,
          res.data?.DATA[i].org_id
        );
        formIk.setFieldValue(`alos[${i}].mandal_id`,res.data?.DATA[i]?.mandal_code);
        // console.log(
        //   "setttttttData",
        //   `alos[${i}].mandal_id`,
        //   res.data?.DATA[i].mandal_code
        // );
        }
      }
    });
  }
  const [AloName, setAloName] = useState([]);
  const[mandals,setmandals]= useState([]);

  function GetAloNames() {
    // http://172.17.205.80:8889/labor/alodtls/506
   
    const ALoNamesUrl = config.url.BOC_URL + "alodtls/" + lgdDisttcode;
    //console.log("UrlAloNAmes",ALoNamesUrl);
    // console.log("MANDALss COMPLETED URL>", URLL);
    CommonAxiosGet(ALoNamesUrl).then((res) => {
    
      if (res.data.alodtls_status === true) {
        setAloName(res.data.alodtls);

        if(res.data.mandals_status === true){
          setmandals(res.data.mandals);
        }
        else{
          // setAloName([]);
          // setmandals([]);

        }
        
       // console.log("AloNAmes", res.data.alodtls);

        // for (let i = 0; i < res.data?.alodtls?.length; i++) {
        // formIk.setFieldValue(`alos[${i}].org_id`,res.data?.DATA[i].org_id);
        // formIk.setFieldValue(`alos[${i}].mandal_id`,res.data?.DATA[i]?.mandal_code+"");
        // console.log("setttttttData",`alos[${i}].mandal_id`,res.data?.DATA[i].mandal_code);
        // }
      }
    });
  }
 
  // const [pendingMandals, setpendingMandals] = useState([]);
  // function GetMappedMandals() {
  //   //const urlmandal = `${config.url.BOC_URL}mandals/${org_id}`;
  //   const urlmandal = config.url.BOC_URL + "mandals/" + lgdDisttcode;
  //   axios.get(urlmandal).then((res) => {
  //     console.log("API DATA mandals>>>>>>", res.data.mandals,lgdDisttcode);

  //     if (res.data.status === true) {
  //       setpendingMandals(res.data);
  //       console.log("i>>>",res.data?.mandals?.length)
  //       for (let i = 0; i < res.data?.mandals?.length; i++) {
        
  //         // formIk.setFieldValue(`vacancyData[${i}].designation`, res?.data?.CollegeVacancyDetails[i]?.designation_id);
  //         formIk.setFieldValue(`alos[${i}].mandal_id`,res.data?.mandals[i]?.mandal_code);
  //        }
  //     }
  //   });
  // }

  let listOfObjects = [];
  let length = mandals?.DATA?.length;
  for (let i = 0; i < length; i++) {
    //year
    if (
      MappedMandals?.DATA !== undefined &&
      MappedMandals?.status === true
    ) {
      listOfObjects.push({
        mandal_id: null,
        org_id: "",
      });
    } else {
    }
  }
  const formIk = useFormik({
    initialValues: {
     // insert_by: "TestAloDetails",
      alos: listOfObjects,
      // [{
      //   mandal_id: "",
      //   org_id: "",
      // }]  
      //
    },
    validationSchema: Yup.object().shape({
      alos: Yup.array().of(
        Yup.object().shape({
          org_id: Yup.string().required("Required")
        })),
}),

    onSubmit: (values) => {
      console.log("values", values);
      let alos=values.alos.filter(ar=>(ar?.org_id || ar?.mandal_id===null))
        //  for(let i=0;i<=OrgDataByMappedMandals?.length;i++){
        //   values.alos[i].mandal_id =OrgDataByMappedMandals[i]?.mandal_code
        //  }
        //console.log("length",values.alos.length)
        // for(let i=0;i<=values.alos.length;i++){
         
        //   values.alos[i].mandal_id=MappedMandals?.DATA[i]?.mandal_code
        //  }
      console.log("filteresdata----------->",alos);   
      Swal.fire({
        title: "Are you sure?",
        text: "Please check",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          // values.alos=alos;
          console.log("values>>>",values)
          // CommonPost.AloEdit(values).then((res) => {
            CommonAxiosPost(config.url.BOC_URL+"alodtlsedit/edit",values).then((res) => {
            console.log("res>>>", res);
            if (res.data != null) {
              if (res.data.scode === "01") {
                console.log("resssssss>>", res.data.sdesc);
                Swal.fire(res?.data?.sdesc);
                navigate("/AloDrillDown");
                
               // console.log("submit data",MappedMandals?.DATA)
                // Swal.fire({
                //   text: res?.data?.ResponseDesc,
                //   icon: "success",
                // }).then((refresh) => {});
              } else {
                failureAlert(res.data.ResponseDesc);
              }
            } else {
              failureAlert(res.data.ResponseDesc);
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Canceled", "Do corrections and then retry :)", "error");
        }
      });
    },
  });
function backNav(){
  navigate("/AloDrillDown");
}
  useEffect(() => {
    MandalsMappedData(); 
    GetAloNames();
  }, []);
 // console.log("optiondata",formIk.values.alos[0])
  return (
    <>
      <Header />
      <div className="main_section"> </div>
      <FormikProvider value={formIk}>
        <Form onSubmit={formIk.handleSubmit} onChange={formIk.handleChange}>
          <Container>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between">
                <div className="inner-herbpage-service-title1">
                  <h1>ALO Details</h1>
                </div>
                <div className="text-right">
                  <button type="button" className="btn btn-success" onClick={backNav}>Back</button>
                </div>
              </Col>
            </Row>
          </Container>
          <Container className="outer-page-content-container">
            {/* <div className="jumbotron mt20 form-card-jnb" style={{ marginTop: "5px" }}> */}

            <Row className="px-4 pt-5">
              <div className="inner-herbpage-service-title-sub">
                <h3 className="text-success" style={{ color: "blue" }}>
                  {localStorage.getItem("distname")}   District  ALO Mandals Mapped
                </h3>
              </div>
              <Table className="table table-condensed table-bordered table-striped table-responsive mt-3 mb-5">
              
                <thead>
                  <tr>
                    <th>S.No</th>
                    {/* <th>District</th> */}
                    <th>Mandals Mapped</th>
                    <th>ALO Office</th>
                  </tr>
                </thead>
                <tbody>
                
                    {MappedMandals?.length > 0 &&
                    MappedMandals?.map((data, i) => {
                      return (
                        <tr>
                          <td>{i + 1}</td>
                          <td style={{textAlign:"center"}}>
                            <Field
                              type="hidden"
                              name={`alos[${i}].mandal_id`}
                              className="form-control w-20 nb-1"
                            />
                            {data.mandal_name}
                          </td>
                          <td style={{ width: '580px' }}>
                            <Field
                              component="select"
                              name={`alos[${i}].org_id`}
                              className="form-control w-20 nb-1"
                              menuPlacement="auto"
                              menuPosition="fixed"
                              required
                            >
                              <option value="">--Select--</option>
                              {AloName !== undefined &&
                                AloName?.map((ms, i) => {

                                  return (
                                    <option key={i} value={ms.org_id}>
                                      {ms.org_name}
                                    </option>
                                  );
                                })}
                            </Field>
                            <ErrorMessage name={`alos[${i}].org_id`} component="div" className="text-danger" />
                          </td>
                       
                        </tr>
                      );
                    })}
                </tbody>
               
              </Table>
            </Row>
            <jnb.Row>
              <jnb.Col xs={12} sm={12} md={12} lg={11} xl={11} xxl={11}>
                <div className="d-flex flex-row justify-content-end px-3">
                  <jnb.Button type="submit" className="btn btn-success">
                    Update
                  </jnb.Button>
                </div>
              </jnb.Col>
            </jnb.Row>
          </Container>
        </Form>
      </FormikProvider>
    </>
  );
}
